import { Play, Pause, Volume2, Loader2 } from "lucide-react";
import { useRadio } from "@/context/RadioContext";

const PersistentPlayer = () => {
  const { status, toggle, volume, setVolume, station } = useRadio();
  const playing = status === "playing";
  const loading = status === "loading";

  return (
    <div
      data-testid="persistent-radio-player"
      className="fixed bottom-0 inset-x-0 z-50 bg-[#10121A]/95 backdrop-blur-2xl border-t border-[#232638] shadow-[0_-10px_30px_rgba(0,0,0,0.8)]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center gap-4 sm:gap-6">
        <button
          data-testid="radio-player-toggle"
          onClick={toggle}
          aria-label={playing ? "Pausar rádio" : "Tocar rádio ao vivo"}
          className="w-11 h-11 shrink-0 rounded-full bg-amber-400 text-[#08090C] flex items-center justify-center hover:bg-amber-300 hover:scale-105 transition-all duration-300"
        >
          {loading ? <Loader2 size={18} className="animate-spin" /> : playing ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
        </button>

        <div className={`flex items-end gap-[3px] h-6 shrink-0 ${playing ? "" : "eq-paused"}`} aria-hidden="true">
          {[0, 1, 2, 3, 4].map((i) => (
            <span
              key={i}
              className="eq-bar w-[3px] bg-amber-400 rounded-sm"
              style={{ height: "100%", animationDelay: `${i * 0.13}s`, animationDuration: `${0.7 + i * 0.09}s` }}
            />
          ))}
        </div>

        <div className="min-w-0 flex-1">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 truncate">{station}</p>
          <p className="font-display text-sm font-bold uppercase tracking-tight truncate">
            {status === "error" ? <span className="text-[#E11D48]">Stream indisponível — tente de novo</span> : "Clássicos do Funk — Ao vivo"}
          </p>
        </div>

        <span
          data-testid="player-live-badge"
          className={`hidden sm:inline-flex font-mono text-[10px] uppercase tracking-[0.25em] px-3 py-1.5 rounded-full ${
            playing ? "bg-[#E11D48] text-white animate-live" : "bg-[#181A26] text-zinc-400"
          }`}
        >
          {playing ? "Ao vivo" : "24h"}
        </span>

        <div className="hidden sm:flex items-center gap-2 shrink-0">
          <Volume2 size={15} className="text-zinc-500" />
          <input
            type="range"
            min="0"
            max="1"
            step="0.05"
            value={volume}
            onChange={(e) => setVolume(Number(e.target.value))}
            data-testid="radio-volume-slider"
            aria-label="Volume"
            className="w-24 accent-amber-400"
          />
        </div>
      </div>
    </div>
  );
};

export default PersistentPlayer;
